<template>
    <component
        :is="'VuePerfectScrollbar'"
        ref="filterScroll"
        :class="[
            'filters_scroll_area',
            rules.is_teacher && 'aside_scroll_teacher',
        ]"
        :settings="settings"
        :key="$vs.rtl"
    >
        <div class="todo__filters-container">
            <div v-if="!loading && Object.keys(filters).length">
                <div class="px-6 py-4">
                    <!-- Кнопка сбросить фильтр -->
                    <div class="flex cursor-pointer" @click="filterRouteAll()">
                        <feather-icon
                            icon="LayersIcon"
                            svgClasses="h-6 w-6"
                        ></feather-icon>
                        <span class="text-lg ml-3">{{ $t("show_all") }}</span>
                    </div>
                </div>

                <vs-divider class="mb-0 mt-0"></vs-divider>

                <!-- Фильтр по учеб году -->
                <div
                    class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid"
                    v-if="filters.study_period"
                >
                    <h5 class="mb-3">{{ $t("study_period") }}</h5>
                    <multiselect
                        :custom-label="stiduPeriodLabel"
                        v-model="filterActive.study_period_uid"
                        :options="filters.study_period"
                        selectedLabel="Выбрано"
                        :placeholder="$t('study_period')"
                        deselectLabel=""
                        selectLabel=""
                        @select="multiselectAction"
                        @remove="multiselectRemove"
                        track-by="uid"
                    >
                        <template slot="singleLabel" slot-scope="props">
                            {{ props.option.start }} - {{ props.option.end }}
                        </template>
                        <template slot="option" slot-scope="props">
                            {{ props.option.start }} - {{ props.option.end }}
                        </template>
                        <div slot="noOptions">{{ $t("no_data_text") }}</div>
                    </multiselect>
                </div>

                <!-- Фильтр по учеб плану -->
                <div
                    class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid"
                    v-if="filters.study_plan"
                >
                    <h5 class="mb-3">{{ $t("study_plan") }}</h5>
                    <multiselect
                        label="education_program__name"
                        v-model="filterActive.study_plan_uid"
                        :options="filters.study_plan"
                        selectedLabel="Выбрано"
                        :placeholder="$t('study_plan')"
                        deselectLabel=""
                        selectLabel=""
                        @select="multiselectAction"
                        @remove="multiselectRemove"
                        track-by="uid"
                    >
                        <template slot="singleLabel" slot-scope="props">{{
                            props.option.education_program__name
                        }}</template>
                        <template slot="option" slot-scope="props">
                            {{ props.option.education_program__name }}
                        </template>
                        <div slot="noOptions">{{ $t("no_data_text") }}</div>
                    </multiselect>
                </div>

                <!-- Фильтр по дисциплине -->
                <div
                    class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid"
                    v-if="filters.discipline"
                >
                    <h5 class="mb-3">{{ $t("discipline") }}</h5>
                        <multiselect
                            label="discipline_name"
                            v-model="filterActive.student_discipline_uid"
                            :options="filters.discipline"
                            selectedLabel="Выбрано"
                            :placeholder="$t('discipline')"
                            @open="openSelect()"
                            class="multiselect__single__discipline"
                            @close="selectClose()"
                            deselectLabel=""
                            selectLabel=""
                            @select="multiselectAction"
                            @remove="multiselectRemove"
                            track-by="uid"
                        >
                            <template slot="singleLabel" slot-scope="props">
                                {{ props.option.discipline_name }}
                            </template>
                            <template slot="option" slot-scope="props">
                                {{ props.option.discipline_name }}
                            </template>
                            <div slot="noOptions">{{ $t("no_data_text") }}</div>
                        </multiselect>
                </div>

                <!-- Фильтр по курсу -->
                <div
                    class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid"
                    v-if="filters.courses"
                >
                    <h5 class="mb-3">{{ $t("course") }}</h5>
                    <multiselect
                        label="uid"
                        v-model="filterActive.course"
                        :options="filters.courses"
                        selectedLabel="Выбрано"
                        :placeholder="$t('course')"
                        deselectLabel=""
                        selectLabel=""
                        @select="multiselectAction"
                        @remove="multiselectRemove"
                        track-by="uid"
                    >
                        <template slot="singleLabel" slot-scope="props">{{
                            props.option.uid
                        }}</template>
                        <template slot="option" slot-scope="props">
                            {{ props.option.uid }}
                        </template>
                        <div slot="noOptions">{{ $t("no_data_text") }}</div>
                    </multiselect>
                </div>

                <!-- Фильтр по Академическому периоду -->
                <div
                    class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid"
                    v-if="filters.acad_periods"
                >
                    <h5 class="mb-3">{{ $t("acad_periods") }}</h5>
                    <multiselect
                        label="name"
                        v-model="filterActive.acad_period_uid"
                        :options="filters.acad_periods"
                        selectedLabel="Выбрано"
                        :placeholder="$t('acad_periods')"
                        deselectLabel=""
                        selectLabel=""
                        @select="multiselectAction"
                        @remove="multiselectRemove"
                        track-by="uid"
                    >
                        <template slot="singleLabel" slot-scope="props">{{
                            props.option.name
                        }}</template>
                        <template slot="option" slot-scope="props">
                            {{ props.option.name }}
                        </template>
                        <div slot="noOptions">{{ $t("no_data_text") }}</div>
                    </multiselect>
                </div>

                <!-- Фильтр по языку -->
                <div class="px-6 py-4" v-if="filters.language">
                    <h5 class="mb-3">{{ $t("language") }}</h5>
                    <multiselect
                        label="name"
                        v-model="filterActive.language_uid"
                        :options="filters.language"
                        selectedLabel="Выбрано"
                        :placeholder="$t('language')"
                        deselectLabel=""
                        selectLabel=""
                        @select="multiselectAction"
                        @remove="multiselectRemove"
                        track-by="uid"
                    >
                        <template slot="singleLabel" slot-scope="props">{{
                            props.option.name
                        }}</template>
                        <template slot="option" slot-scope="props">
                            {{ props.option.name }}
                        </template>
                        <div slot="noOptions">{{ $t("no_data_text") }}</div>
                    </multiselect>
                </div>

                <div class="px-6 py-4 lg:hidden">
                    <vs-button @click="sidebarToggle()" class="w-full">{{$t('apply')}}</vs-button>
                </div>
            </div>
        </div>
    </component>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    props: {
        itemHandler: {
            type: Function,
            default: () => {},
        },
        activeTab: {
            type: Number,
            default: 0,
        },
        rules: {
            type: Object,
        },
        sidebarToggle: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            filterActive: {
                student_discipline_uid: "",
                language_uid: "",
                acad_period_uid: "",
                study_plan_uid: "",
                study_period_uid: "",
                course: "",
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },
            loading: false,
        };
    },
    computed: {
        filters() {
            return this.$store.getters["emc/getFilters"];
        },
        scrollbarTag() {
            return this.$store.getters.scrollbarTag;
        },
    },
    methods: {
         selectClose() {
             // Инициализируем скролл
             this.$refs["filterScroll"].__init();
         },
        openSelect() {
            // Останавливаем скролл
            this.$refs["filterScroll"].__uninit();
        },
        stiduPeriodLabel({ start, end }) {
            // Подставляем лэйбл для поиска в поле Учебный год
            return `${ start } - ${ end }`;
        },
        upadteTabEmc() {
            // В зависимости от выбранного таба, очищаем список умк
            if (this.activeTab === 0) this.$store.commit("emc/CLEAR_EMC");
            else this.$store.commit("emc/CLEAR_EMC_TEACHER");

            // Обновляем список УМК с ключем update родительской функцией
            this.itemHandler({ update: true });
        },
        multiselectRemove(item) {
            // При нажатии на активный фильтр, убираем его и обновляем список умк
            let filterType;

            if (item.speciality__name) filterType = "study_plan_uid";
            else if (item.discipline_name)
                filterType = "student_discipline_uid";
            else if (item.type) filterType = "course";
            else if (item.period_type) filterType = "acad_period_uid";
            else if (item.is_study_year) filterType = "study_period_uid";
            else filterType = "language_uid";

            let query = Object.assign({}, this.$route.query);
            delete query[filterType];
            this.$router.push({ query });
            this.upadteTabEmc();
        },
        multiselectAction(item) {
            // При нажатии на фильтр, добавляем query параметр в роут, обновляем список умк
            let filterType;

            if (item.speciality__name) filterType = "study_plan_uid";
            else if (item.discipline_name)
                filterType = "student_discipline_uid";
            else if (item.type) filterType = "course";
            else if (item.period_type) filterType = "acad_period_uid";
            else if (item.is_study_year) filterType = "study_period_uid";
            else filterType = "language_uid";

            // if(!Object.values(this.$route.query).join().includes((filterType === 'student_discipline_uid') ? item.discipline : item.uid))
            let query = Object.assign({}, this.$route.query);
            query[filterType] =
                filterType === "student_discipline_uid"
                    ? item.discipline
                    : item.uid;
            this.$router.push({ query });
            this.upadteTabEmc();
        },
        filterRouteAll() {
            // При нажатии на кнопку показать все, убираем все фильтры и обновляем список умк
            if (Object.keys(this.$route.query).length) {
                this.$router.push({ name: "emc" });

                for (let query in this.filterActive) {
                    this.filterActive[query] = "";
                }

                this.upadteTabEmc();
            }
        },
        async getActionFilters() {
            for (let query in this.filterActive) {
                this.filterActive[query] = "";
            }

            try {
                this.loading = true;
                this.$vs.loading();

                // Получаем список фильтров с сервера
                const res = await this.$store.dispatch(
                    "emc/fetchDisciplinesFilters"
                );
                if (Object.keys(this.$route.query).length) {
                    for (let query in this.$route.query) {
                        // Если в роуте ключ query не пустой, прогоняем его циклом, и подставляем в фильтр нужные значения
                        let filterKey;

                        switch (query) {
                        case "student_discipline_uid":
                            filterKey = "discipline";
                            break;
                        case "course":
                            filterKey = "courses";
                            break;
                        case "study_period_uid":
                            filterKey = "study_period";
                            break;
                        case "study_plan_uid":
                            filterKey = "study_plan";
                            break;
                        case "acad_period_uid":
                            filterKey = "acad_periods";
                            break;
                        case "language_uid":
                            filterKey = "language";
                            break;
                        }
                        this.filterActive[query] = res[filterKey].find(
                            (item) => {
                                if (filterKey === "discipline")
                                    return (
                                        item.discipline ===
                                        this.$route.query[query]
                                    );
                                else
                                    return (
                                        item.uid === this.$route.query[query]
                                    );
                            }
                        );
                    }
                }
            } catch (error) {
                this.$vs.notify({
                    text: error,
                    color: "danger",
                });
            } finally {
                this.$vs.loading.close();
                this.loading = false;
            }
        },
    },
    components: {
        VuePerfectScrollbar,
    },
    created: function () {
        // Запрашиваем фильтры с сервера
        this.getActionFilters();
    },
};
</script>

<style lang="scss">
// Что бы мультиселект с дисциплиной отображался правильно
//div.multiselect__content-wrapper{
//    position: relative;
//    z-index: 9999 !important;
//    max-height: 190px !important;
//}
.todo__filters-container{
    .multiselect__single__discipline{
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

</style>
